/**
 * Analytics API — client-side tracker & admin data fetcher
 * Uses relative URLs to hit Vercel serverless functions in production.
 */

const API = process.env.REACT_APP_API_URL || '';

function getAdminHeaders() {
  try {
    const raw = localStorage.getItem('fvl_auth');
    if (raw) {
      const user = JSON.parse(raw);
      if (user.credential) return { 'Authorization': `Bearer ${user.credential}` };
      return { 'x-admin-email': user.email || '' };
    }
  } catch {}
  return {};
}

/* ═══════════════════════════════════════
   TRACKER — called from every page
   ═══════════════════════════════════════ */

export function trackPageView(pagePath) {
  if (!pagePath) return;
  fetch(`${API}/api/analytics/pageview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      path: pagePath,
      referrer: document.referrer || '',
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
    }),
  }).catch(() => {});  // fire-and-forget
}

export function trackClick(pagePath, x, y, element) {
  fetch(`${API}/api/analytics/event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      path: pagePath,
      eventType: 'click',
      x: Math.round(x),
      y: Math.round(y),
      element: element || '',
    }),
  }).catch(() => {});
}

export function trackScroll(pagePath, scrollDepth) {
  fetch(`${API}/api/analytics/event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      path: pagePath,
      eventType: 'scroll',
      scrollDepth: Math.round(scrollDepth),
    }),
  }).catch(() => {});
}

/* ═══════════════════════════════════════
   ADMIN — fetch analytics data
   ═══════════════════════════════════════ */

export async function apiGetAnalyticsSummary() {
  try {
    const res = await fetch(`${API}/api/analytics/summary`, {
      headers: { ...getAdminHeaders() },
    });
    return await res.json();
  } catch {
    return { ok: false, data: null };
  }
}

export async function apiGetAllAnalytics() {
  try {
    const res = await fetch(`${API}/api/analytics`, {
      headers: { ...getAdminHeaders() },
    });
    return await res.json();
  } catch {
    return { ok: false, data: [] };
  }
}

export async function apiClearAnalytics() {
  try {
    const res = await fetch(`${API}/api/analytics`, {
      method: 'DELETE',
      headers: { ...getAdminHeaders() },
    });
    return await res.json();
  } catch {
    return { ok: false };
  }
}
